export default "__VITE_ASSET__9f5c85a3__"